// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__JIJAr","inputWrap":"CustomTip_inputWrap__2PgXe"};